import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import { 
  Button, 
  Card, 
  Col, 
  Container, 
  Form, 
  Modal, 
  Row, 
  Spinner,
  Table,
  Badge,
  InputGroup,
  Pagination
} from 'react-bootstrap';
// import { FaPencilAlt, FaPlus, FaTrash, FaSearch } from 'react-icons/fa';
import { Pencil, Plus, Trash, Search } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import Header from '../../layouts/Header';
import { useSelector } from 'react-redux';

const StorageLocation = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [materialAccess, setMaterialAccess] = useState([]);

    console.log("Access :", access);
    
    useEffect(() => {
      if (Array.isArray(access)) {
        const filteredAccess = access?.filter((perm) =>
          perm?.startsWith("StorageLocation:")
        );
        setMaterialAccess(filteredAccess);
      }
    }, [access]);

    console.log("Material Access:", materialAccess);

    const accessToken = localStorage.getItem('authToken');
    const [storageLocationList, setStorageLocationList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [storageLocationId, setStorageLocationId] = useState('');
    const [addBtnLoading, setAddBtnLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [storageLocationInputData, setStorageLocationInputData] = useState({
        name: '',
        address: '',
        city: '',
        state: ''
    });
    const [openAddModal, setOpenAddModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [openEditModal, setOpenEditModal] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [errors, setErrors] = useState({});
    const [editErrors, setEditErrors] = useState({});
    const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
    const [filterLoading, setFilterLoading] = useState(false);
    const [filterState, setFilterState] = useState("");
    const [filterCity, setFilterCity] = useState("");

    const columns = [
        {
            Header: "Sr.No",
            accessor: "serialNumber",
            width: 90,
            Cell: ({ row }) => <div className="fs-7">{row.index + 1}</div>
        },
        {
            Header: "NAME",
            accessor: "name",
            width: 220,
            Cell: ({ value }) => <div className="fs-7">{value || "--------"}</div>
        },
        {
            Header: "ADDRESS",
            accessor: "address",
            width: 290,
            Cell: ({ value }) => <div className="fs-7">{value || "--------"}</div>
        },
        {
            Header: "CITY",
            accessor: "city",
            Cell: ({ value }) => <div className="fs-7">{value || "--------"}</div>
        },
        {
            Header: "STATE",
            accessor: "state",
            Cell: ({ value }) => <div className="fs-7">{value || "--------"}</div>
        },
        // Conditionally add ACTIONS column
        ...(
            (materialAccess.includes("StorageLocation:update") || materialAccess.includes("StorageLocation:delete") ||  email === "contact@xpansecafe.com")
            ? [
                {
                    Header: "ACTIONS",
                    accessor: "actions",
                    width: 165,
                    Cell: ({ row }) => (
                        <div className="d-flex justify-content-around align-items-center">
                            {(materialAccess.includes("StorageLocation:update") || email === 'contact@xpansecafe.com') && (
                                <>
                                    <Button
                                        variant="link"
                                        onClick={() => handleEditModal(row.original)}
                                        className="text-primary p-0 d-flex align-items-center gap-1"
                                    >
                                        <Pencil size={12} /> EDIT
                                    </Button>
                                    <span className="text-muted">|</span>
                                </>
                            )}
                            {(materialAccess.includes("StorageLocation:delete") || email === 'contact@xpansecafe.com') && (
                                <Button
                                    variant="link"
                                    onClick={() => handleDeleteModal(row.original)}
                                    className="text-danger p-0 d-flex align-items-center gap-1"
                                >
                                    <Trash size={12} /> DELETE
                                </Button>
                            )}
                        </div>
                    )
                }
            ] : []
        )
    ];

    const handleFilter = async () => {
        setFilterLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const params = {};
 
            if (filterState) params.state = filterState;
            if (filterCity) params.city = filterCity;
 
            const response = await axios.get("storage-location", {
                headers,
                params,
            });
            
            const dataWithSerial = response?.data?.data?.storageLocations.map((item, index) => ({
                ...item,
                serialNumber: index + 1
            }));
          
            setStorageLocationList(dataWithSerial);
            setFilteredData(dataWithSerial);
            
            if(filterState !== "" || filterCity !== "") {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                const errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setFilterLoading(false);
        }
    };

    const handleAddNewOpenModal = () => {
        setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setStorageLocationInputData({
            name: '',
            address: '',
            city: '',
            state: ''
        });
        setErrors({});
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStorageLocationInputData(prev => ({ ...prev, [name]: value }));
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        if(validateForm()) {
            setAddBtnLoading(true);
            try {
                const headers = {
                    Authorization: `Bearer ${accessToken}`
                };
                const response = await axios.post('storage-location', storageLocationInputData, { headers });
                if (response?.data?.status === true) {
                    toast.success(response?.data?.data?.message, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                    handleFilter();
                    handleCloseAddModal();
                }
            } catch (error) {
                if (error?.response) {
                    let errorMessage = '';
                    if (error.response?.status === 406) {
                        errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                    } else if (error.response?.status === 412) {
                        errorMessage = error?.response?.data?.data?.message;
                    } else if (error.response?.status === 500) {
                        errorMessage = error?.response?.data?.error;
                    }
        
                    toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                }
            } finally {
                setAddBtnLoading(false);
            }
        }
    }

    const handleEditModal = (data) => {        
        setOpenEditModal(true);        
        setEditedData({
            _id: data?._id,
            name: data?.name,
            address: data?.address,
            city: data?.city,
            state: data?.state
        });
        setEditErrors({});
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({ ...prev, [name]: value }));
    }

    const handleEditSubmit = async(e) => {
        e.preventDefault();
        if(validateEditForm()) {
            setIsEditBtnLoading(true);
            try {
                const headers = {
                    Authorization: `Bearer ${accessToken}`
                };
                const response = await axios.put('storage-location', editedData, { headers });
                if (response?.data?.status === true) {
                    toast.success(response?.data?.data?.message, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                    handleFilter();
                    setOpenEditModal(false);
                }
            } catch (error) {
                if (error?.response) {
                    let errorMessage = '';
                    if (error.response?.status === 406) {
                        errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                    } else if (error.response?.status === 412) {
                        errorMessage = error?.response?.data?.data?.message;
                    } else if (error.response?.status === 500) {
                        errorMessage = error?.response?.data?.error;
                    }
                    toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                }
            } finally {
                setIsEditBtnLoading(false);
            }
        }
    }

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    }

    const handleDeleteModal = (data) => {
        setOpenDeleteModal(true);
        setStorageLocationId(data._id);
    }

    const handleDeleteStorageLocation = async() => {
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const data = {
                _id: storageLocationId
            };
            const response = await axios.delete('storage-location', { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                handleFilter();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response?.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    }

    const validateForm = () => {
        const newErrors = {};
        const trimmedName = storageLocationInputData?.name?.trim() || '';
        const trimmedAddress = storageLocationInputData?.address?.trim() || '';
        const trimmedCity = storageLocationInputData?.city?.trim() || '';
        const trimmedState = storageLocationInputData?.state?.trim() || '';

        if(!trimmedName) {
            newErrors.name = "Name is required";
        } else if (trimmedName.length < 2) {
            newErrors.name = "Name must contain at least 2 letters";
        } 

        if (!trimmedAddress) {
            newErrors.address = "Address is required";
        } else if (trimmedAddress.length < 2) {
            newErrors.address = "Address must contain at least 2 letters";
        }

        if (!trimmedCity) {
            newErrors.city = "City is required";
        } else if (trimmedCity.length < 2) {
            newErrors.city = "City must contain at least 2 letters";
        }

        if (!trimmedState) {
            newErrors.state = "State is required";
        } else if (trimmedState.length < 2) {
            newErrors.state = "State must contain at least 2 letters";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const validateEditForm = () => {
        const newErrors = {};
        const trimmedName = editedData?.name?.trim() || '';
        const trimmedAddress = editedData?.address?.trim() || '';
        const trimmedCity = editedData?.city?.trim() || '';
        const trimmedState = editedData?.state?.trim() || '';

        if(!trimmedName) {
            newErrors.name = "Name is required";
        } else if (trimmedName.length < 2) {
            newErrors.name = "Name must contain at least 2 letters";
        } 

        if (!trimmedAddress) {
            newErrors.address = "Address is required";
        } else if (trimmedAddress.length < 2) {
            newErrors.address = "Address must contain at least 2 letters";
        }

        if (!trimmedCity) {
            newErrors.city = "City is required";
        } else if (trimmedCity.length < 2) {
            newErrors.city = "City must contain at least 2 letters";
        }

        if (!trimmedState) {
            newErrors.state = "State is required";
        } else if (trimmedState.length < 2) {
            newErrors.state = "State must contain at least 2 letters";
        }

        setEditErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handlePageChange = (page) => {
        setPagination(prev => ({ ...prev, page }));
    };
      
    const handleRowsPerPageChange = (e) => {
        setPagination({ page: 1, rowsPerPage: Number(e.target.value) });
    };
    
    const getPaginatedData = () => {
        const startIndex = (pagination.page - 1) * pagination.rowsPerPage;
        const endIndex = startIndex + pagination.rowsPerPage;
        return filteredData.slice(startIndex, endIndex);
    };

    useEffect(() => {
        handleFilter();
    }, []);

    useEffect(() => {
        const result = storageLocationList.filter(item => 
            item?.name?.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredData(result);
        setPagination(prev => ({ ...prev, page: 1 }));
    }, [searchText, storageLocationList]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-white border-0 py-3">
                        <h4 className="mb-0 fw-bold">
                            <i className="bi bi-pin-map me-2"></i>STORAGE LOCATION MANAGEMENT
                        </h4>
                    </Card.Header>
                    <hr className="my-0" />
                    
                    <Card.Body>
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3 mb-4">
                            <Row className="g-3">
                                <Col md={3}>
                                    <Form.Group controlId="filterCity">
                                        <Form.Label className="fw-semibold">
                                            <i className="bi bi-building me-2"></i>City
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter city"
                                            value={filterCity}
                                            onChange={(e) => setFilterCity(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="filterState">
                                        <Form.Label className="fw-semibold">
                                            <i className="bi bi-globe me-2"></i>State
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter state"
                                            value={filterState}
                                            onChange={(e) => setFilterState(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3} className="d-flex align-items-end">
                                    <Button
                                        variant="primary"
                                        onClick={handleFilter}
                                        className="w-100"
                                        disabled={filterLoading}
                                    >
                                        {filterLoading ? (
                                            <Spinner size="sm" animation="border" />
                                        ) : (
                                            "Apply Filters"
                                        )}
                                    </Button>
                                </Col>
                                <Col md={3} className="d-flex align-items-end">
                                    {(materialAccess?.includes("StorageLocation:add") || email === 'contact@xpansecafe.com') && (
                                        <Button
                                            variant="warning"
                                            onClick={handleAddNewOpenModal}
                                            className="w-100 d-flex align-items-center justify-content-center gap-2"
                                        >
                                            <Plus /> Add New Location
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </div>

                        {/* Search and Table Section */}
                        <div className="mb-4 p-3 bg-light rounded-3">
                            <Row className="g-3 align-items-center mb-3">
                                <Col md={6}>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search by location name..."
                                            value={searchText}
                                            onChange={handleSearchChange}
                                        />
                                        <Button variant="outline-secondary">
                                            <Search />
                                        </Button>
                                    </InputGroup>
                                </Col>
                            </Row>

                            <div className="table-responsive">
                                {(materialAccess?.includes("StorageLocation:get") || email === 'contact@xpansecafe.com') && (
                                    <Table striped bordered hover className="mb-0">
                                        <thead className="bg-white">
                                            <tr>
                                                {columns?.map((column, idx) => (
                                                    <th key={idx} width={column.width} style={{ fontSize: '14px' }}>
                                                        {column.Header}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filterLoading ? (
                                                <tr>
                                                    <td colSpan={columns.length} className="text-center py-4">
                                                        <Spinner animation="border" variant="primary" />
                                                        <p className="mt-2 mb-0">Loading storage locations...</p>
                                                    </td>
                                                </tr>
                                            ) : getPaginatedData().length > 0 ? (
                                                getPaginatedData().map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {columns.map((column, colIndex) => {
                                                            if (column.Cell) {
                                                                return (
                                                                    <td key={colIndex}>
                                                                        {column.Cell({ row: { original: row, index: rowIndex }, value: row[column.accessor] })}
                                                                    </td>
                                                                );
                                                            }
                                                            return (
                                                                <td key={colIndex}>
                                                                    {row[column.accessor] || "--------"}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={columns.length} className="text-center py-4">
                                                        <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                                                        <p className="mt-2 mb-0 text-muted">
                                                            No storage locations found
                                                        </p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                )}
                            </div>

                            {/* Pagination */}
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div className="d-flex align-items-center">
                                    <span className="me-2 text-muted">Show</span>
                                    <Form.Select
                                        style={{ width: 'auto' }}
                                        value={pagination.rowsPerPage}
                                        onChange={handleRowsPerPageChange}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </Form.Select>
                                    <span className="ms-2 text-muted">entries</span>
                                </div>
                                
                                <div className="d-flex align-items-center">
                                    <Pagination className="mb-0">
                                        <Pagination.Prev
                                            disabled={pagination.page === 1}
                                            onClick={() => handlePageChange(pagination.page - 1)}
                                        />
                                        {Array.from({ length: Math.ceil(filteredData.length / pagination.rowsPerPage) }, (_, i) => (
                                            <Pagination.Item
                                                key={i + 1}
                                                active={i + 1 === pagination.page}
                                                onClick={() => handlePageChange(i + 1)}
                                            >
                                                {i + 1}
                                            </Pagination.Item>
                                        ))}
                                        <Pagination.Next
                                            disabled={pagination.page === Math.ceil(filteredData.length / pagination.rowsPerPage)}
                                            onClick={() => handlePageChange(pagination.page + 1)}
                                        />
                                    </Pagination>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                {/* Add Location Modal */}
                <Modal show={openAddModal} onHide={handleCloseAddModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Storage Location</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Storage Location Name"
                                    name="name"
                                    value={storageLocationInputData.name}
                                    onChange={handleChange}
                                    isInvalid={!!errors.name}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.name}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    City <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="City"
                                    name="city"
                                    value={storageLocationInputData.city}
                                    onChange={handleChange}
                                    isInvalid={!!errors.city}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.city}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    State <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="State"
                                    name="state"
                                    value={storageLocationInputData.state}
                                    onChange={handleChange}
                                    isInvalid={!!errors.state}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.state}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Address <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Address"
                                    name="address"
                                    value={storageLocationInputData.address}
                                    onChange={handleChange}
                                    isInvalid={!!errors.address}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.address}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseAddModal}>
                                Cancel
                            </Button>
                            <Button variant="primary" type="submit" disabled={addBtnLoading}>
                                {addBtnLoading ? (
                                    <Spinner size="sm" animation="border" />
                                ) : (
                                    "Add Location"
                                )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Edit Location Modal */}
                <Modal show={openEditModal} onHide={() => setOpenEditModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Storage Location</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={handleEditSubmit}>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Name"
                                    name="name"
                                    value={editedData.name}
                                    onChange={handleEditChange}
                                    isInvalid={!!editErrors.name}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {editErrors.name}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    City <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="City"
                                    name="city"
                                    value={editedData.city}
                                    onChange={handleEditChange}
                                    isInvalid={!!editErrors.city}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {editErrors.city}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    State <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="State"
                                    name="state"
                                    value={editedData.state}
                                    onChange={handleEditChange}
                                    isInvalid={!!editErrors.state}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {editErrors.state}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Address <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Address"
                                    name="address"
                                    value={editedData.address}
                                    onChange={handleEditChange}
                                    isInvalid={!!editErrors.address}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {editErrors.address}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setOpenEditModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="primary" type="submit" disabled={isEditBtnLoading}>
                                {isEditBtnLoading ? (
                                    <Spinner size="sm" animation="border" />
                                ) : (
                                    "Save Changes"
                                )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className='text-danger'>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this storage location? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button 
                            variant="danger" 
                            onClick={handleDeleteStorageLocation}
                            disabled={isDeleteBtnLoading}
                        >
                            {isDeleteBtnLoading ? (
                                <Spinner size="sm" animation="border" />
                            ) : (
                                "Delete"
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default StorageLocation;